const initialState = {
    data: [],
  };
  
  const glosowanieOdpowiedziReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_GLOSOWANIE_ODPOWIEDZI':
        return { ...state, data: action.payload };
      default:
        return state;
    }
  };
  
  export default glosowanieOdpowiedziReducer;